import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-err-sse',
  templateUrl: './err-sse.component.html',
  styleUrls: ['./err-sse.component.scss']
})
export class ErrSSEComponent   {

  @Input()
  title: string = ''
  templateSuffix = environment.templateSuffix;

  constructor(private router: Router) { }

  toHome(){
    this.router.navigate(['/home']);
  }

}
